<!-- 
    COMPONENT CIRCLEMENU
-->


<!---------- SCRIPT ---------->

<script lang="ts">

    import { onMount } from "svelte";
    import { flyMode, english, square, deglingos, minitel } from '../store/store';

    let isOpenCircle: boolean = false;
    
    function itemPosition() {
        let items = document.querySelectorAll<HTMLElement>('.circle__item');

        for(var i = 0, l = items.length; i < l; i++) {
            items[i].style.left = (50 - 35*Math.cos(-0.5 * Math.PI - 2*(1/l)*i*Math.PI)).toFixed(4) + "%";  
            items[i].style.top = (50 + 35*Math.sin(-0.5 * Math.PI - 2*(1/l)*i*Math.PI)).toFixed(4) + "%";
        }
    }

    function toogleOpenCircle() {
        isOpenCircle = !isOpenCircle;
    }

    function toDeglingos() {
        square.set(false);
        deglingos.set(true);
        minitel.set(false);
        toogleOpenCircle();
    }

    function toSquare() {
        square.set(true);
        deglingos.set(false);
        minitel.set(false);
        toogleOpenCircle();
    }

    function toFlyMode() {
        $flyMode = !$flyMode
        toogleOpenCircle();
    }

    function toogleFlag() {
        $english = !$english;
        toogleOpenCircle();
    }

    function toMinitel() {
        square.set(false);
        deglingos.set(false);
        minitel.set(true);
        toogleOpenCircle();
    }

    onMount(async () => {
        itemPosition();
    })

</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">

    .circular-menu {
        width: 250px;
        height: 200px;
        margin: 0 auto;
        position: relative;
        opacity: 0;
        animation-name: showHand;
        animation-duration: 3s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
    }

    @keyframes showHand {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .circle {
        width: 250px;
        height: 200px;
        opacity: 0;
        -webkit-transform: scale(0);
        -moz-transform: scale(0);
        transform: scale(0);
        -webkit-transition: all 0.4s ease-out;
        -moz-transition: all 0.4s ease-out;
        transition: all 0.4s ease-out;
        &--open {
            opacity: 1;
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            transform: scale(1);
        }
        &__item {
            text-decoration: none;
            color: $color_primary;
            display: block;
            height: 30px;
            width: 30px;
            line-height: 40px;
            margin-left: -15px;
            margin-top: -15px;
            position: absolute;
            text-align: center;
            cursor: pointer;
            &:hover {
                color: $color_secondary;
            }
            &--selected {
                cursor: inherit;
            }
        }
    }

    .square {
        background-color: $color_primary;
        border: 5px solid $color_tertiary;
        width: 20px;
        height: 20px;
    }

    .deglingos {
        border-radius: 63% 44% 0 106%;
        background-color: $color_secondary;
    }

    .minitel {
        background-color: $color_black;
        border: 5px solid $color_minitel_green;
        width: 20px;
        height: 20px;
    }

    .menuButton {
        position: absolute;
        top: calc(50% - 30px);
        left: calc(50% - 30px);
        text-decoration: none;
        text-align: center;
        color: $color_primary;
        border-radius: 50%;
        display: block;
        height: 40px;
        width: 40px;
        line-height: 40px;
        padding: 10px;
        background: $color_primary;
        cursor: pointer;
        color: $color_secondary;
        &--open {
            background-color: $color_secondary;
        }
        &__img {
            padding: 0 0 0 0;
            height: 40px;
            animation-name: moveYourPear;
            animation-duration: 3s;
            animation-iteration-count: infinite;
            animation-delay: 3s;
            transform-origin: bottom;
            &:hover {
                display: none;
            }
        }
        &__text {
            display: none;
            position: relative;
            margin-top: -40px;
            &:hover {
                display: block;
            }
        }
    }

    @keyframes moveYourPear {
        15% {
            transform: rotate(40deg)
        }
        50% {
            transform: rotate(-30deg)
        }
        70%{
            transform: rotate(0deg)
        }
    }

    .flyMode {
        background-image: url('../images/fly_mode_primary.png');
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        &__deglingos {
            background-image: url('../images/fly_mode_secondary.png');
        }
        &:hover {
            background-image: url('../images/fly_mode_secondary.png');
        }
        &__minitel {
            background-image: url('../images/fly_mode_minitel.png');
            &:hover {
                background-image: url('../images/fly_mode_minitel.png');
            }
        }
    }

    .flag {
        height: 20px;
        background-position: center;
        background-size: 30px;
        &__fr {
            background-image: url('../images/flag-fr.png');
        }
        &__en {
            background-image: url('../images/flag-gb.png');
        }
    }

    @include large {

        .menuButton {
            &:hover {
                background-color: $color_secondary;
            }
        }

    }

</style>
  
  
<!---------- TEMPLATE ---------->

<nav class="circular-menu">

    <div class="{isOpenCircle ? 'circle circle--open' : 'circle'}">
        <div class="circle__item">
            <div class="flyMode" class:flyMode__deglingos={$deglingos} class:flyMode__minitel={$minitel} on:click={() => toFlyMode()}>&nbsp;
            </div>
        </div>
        <div class={$deglingos ? 'circle__item deglingos circle__item--selected' : 'circle__item deglingos'}
            on:click={() => toDeglingos()}>&nbsp;
        </div>
        <div class={$square ? 'circle__item square circle__item--selected' : 'circle__item square'}
            on:click={() => toSquare()}>&nbsp;
        </div>
        <div class={$minitel ? 'circle__item minitel circle__item--selected' : 'circle__item minitel'}
            on:click={() => toMinitel()}>&nbsp;
        </div>
        <div class={$english ? 'circle__item flag flag__fr' : 'circle__item flag flag__en'} on:click={() => toogleFlag()}>&nbsp;</div>
    </div>
    
    <div class="{isOpenCircle ? 'menuButton menuButton--open' : 'menuButton'}" on:click={() => toogleOpenCircle()}>
        <img class="menuButton__img" src="../images/hand_secondary_click.png" alt="hand"/>
        <div class="menuButton__text">click&nbsp;me!</div>
    </div>
  
  </nav>